import { render, staticRenderFns } from "./KeywordForm.vue?vue&type=template&id=07720bc9&scoped=true&"
import script from "./KeywordForm.vue?vue&type=script&lang=js&"
export * from "./KeywordForm.vue?vue&type=script&lang=js&"
import style0 from "./KeywordForm.vue?vue&type=style&index=0&id=07720bc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07720bc9",
  null
  
)

export default component.exports